import { request, seg } from "./http";
import type { PartUrl, StorageUsage, UploadedPart, UploadInit, Video } from "./types";

export const videosApi = {
  list: (workspaceId: string, signal?: AbortSignal) =>
    request<{ videos: Video[]; usage: StorageUsage }>("GET", `/v1/workspaces/${seg(workspaceId)}/videos`, undefined, { signal }),
  get: (id: string) => request<Video>("GET", `/v1/videos/${seg(id)}`),
  rename: (id: string, name: string) => request<Video>("PATCH", `/v1/videos/${seg(id)}`, { name }),
  remove: (id: string) => request<void>("DELETE", `/v1/videos/${seg(id)}`),
  downloadUrl: (id: string) => request<{ url: string }>("GET", `/v1/videos/${seg(id)}/download`).then((r) => r.url),

  initUpload: (workspaceId: string, file: { filename: string; size: number; contentType: string }) =>
    request<UploadInit>("POST", `/v1/workspaces/${seg(workspaceId)}/videos`, file),
  partUrls: (id: string, partNumbers: number[]) =>
    request<{ urls: PartUrl[]; expiresInSeconds: number }>("POST", `/v1/videos/${seg(id)}/upload-parts`, { partNumbers }),
  complete: (id: string, parts: UploadedPart[]) => request<Video>("POST", `/v1/videos/${seg(id)}/complete`, { parts }),
  abort: (id: string) => request<void>("POST", `/v1/videos/${seg(id)}/abort`, {}),
};
